import { Sparkles, X } from "lucide-react";

interface Props {
  count: number;
  /** Import path that produced the batch ("Spot Trawl", "Zotero import", …). */
  source?: string | null;
  /** How many of the batch are still unscored — renders a "scoring…" suffix. */
  scoringCount?: number;
  onSortByNewest: () => void;
  onDismiss: () => void;
}

/** One-shot pill shown while recently-imported papers are highlighted in the
 * table — the single announcement surface for all import paths. "Sort by
 * newest" surfaces the batch (sort + scroll to top); ✕ clears the highlight
 * and restores the default sort. */
export function RecentlyAddedChip({
  count,
  source,
  scoringCount = 0,
  onSortByNewest,
  onDismiss,
}: Props) {
  return (
    <div className="mb-2 inline-flex items-center gap-2 rounded-full border border-[#a6e3a1]/40 bg-[#a6e3a1]/10 py-1 pl-3 pr-1.5 text-xs text-[#a6e3a1]">
      <Sparkles className="size-3.5" />
      <span>
        {count} new paper{count === 1 ? "" : "s"}
        {source ? ` via ${source}` : ""}
        {scoringCount > 0 && (
          <span className="text-[#a6e3a1]/70"> · {scoringCount} scoring…</span>
        )}
      </span>
      <button
        type="button"
        onClick={onSortByNewest}
        className="font-medium underline-offset-2 hover:underline"
      >
        Sort by newest
      </button>
      <button
        type="button"
        aria-label="Dismiss new-paper highlight"
        onClick={onDismiss}
        className="rounded-full p-0.5 hover:bg-[#a6e3a1]/20"
      >
        <X className="size-3" />
      </button>
    </div>
  );
}
